import { render, staticRenderFns } from "./TotalLogDataTable.vue?vue&type=template&id=27feb532&scoped=true"
import script from "./TotalLogDataTable.vue?vue&type=script&lang=js"
export * from "./TotalLogDataTable.vue?vue&type=script&lang=js"
import style0 from "./TotalLogDataTable.vue?vue&type=style&index=0&id=27feb532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27feb532",
  null
  
)

export default component.exports